import React from "react";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  label: {
    display: "flex",
    "flex-direction": "column",
    color: "white",
    "font-size": 14,
    margin: [15, 0, 0],
    position: "relative",
  },
  grey: {
    color: "#9F9F9F",
  },
});

const Label = ({ name, required, optional, children, ...props }) => {
  const classes = useStyles();
  return (
    <label className={classes.label} {...props}>
      <span>
        {name.toUpperCase()}{" "}
        {required && <span className={classes.grey}>(required)</span>}
        {optional && <span className={classes.grey}>(optional)</span>}
      </span>
      {children}
    </label>
  );
};

export default Label;
